// extracted by mini-css-extract-plugin
module.exports = {"weblink":"WebLink_weblink__1YVL3","fadeIn":"WebLink_fadeIn__1_dnp","scaleXin":"WebLink_scaleXin__Motgw"};